import { render, staticRenderFns } from "./RoleManagement.vue?vue&type=template&id=4e715c3c&scoped=true"
import script from "./RoleManagement.vue?vue&type=script&lang=js"
export * from "./RoleManagement.vue?vue&type=script&lang=js"
import style0 from "./RoleManagement.vue?vue&type=style&index=0&id=4e715c3c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e715c3c",
  null
  
)

export default component.exports